import { render, staticRenderFns } from "./ClientModal.vue?vue&type=template&id=b29050b0&scoped=true"
import script from "./ClientModal.vue?vue&type=script&lang=js"
export * from "./ClientModal.vue?vue&type=script&lang=js"
import style0 from "./ClientModal.vue?vue&type=style&index=0&id=b29050b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b29050b0",
  null
  
)

export default component.exports